import { SharedUtilitiesModule } from '../../utilities/shared-utilities.module';
import moment from "moment";

export default function getDocDefinition(
  printParams,
  agGridApi,
  agGridColumnApi
) {
  const {
    PDF_TITLE,
    PDF_SUB_TITLE,
    PDF_GENERATED_ON,
    PDF_HEADER_COLOR,
    PDF_INNER_BORDER_COLOR,
    PDF_OUTER_BORDER_COLOR,
    PDF_ODD_BKG_COLOR,
    PDF_EVEN_BKG_COLOR,
    PDF_HEADER_HEIGHT,
    PDF_ROW_HEIGHT,
    PDF_PAGE_ORITENTATION,
    PDF_WITH_CELL_FORMATTING,
    PDF_WITH_COLUMNS_AS_LINKS,
    PDF_SELECTED_ROWS_ONLY,
    PDF_WITH_HEADER_IMAGE,
    PDF_WITH_FOOTER_PAGE_COUNT,
    PDF_LOGO,
    PDF_FILENAME,
    PDF_PAGE_SIZE,
    PDF_ROW_BOLD,
    PDF_ROW_PERCENTAGE,
    PDF_ROW_TOTAL,
    PDF_NOT_SHOWING_GROUP_TOTAL,
    PDF_HIDE_GROUP_COLUMN,
    PDF_SUMMARY,
  } = printParams;

  return (function () {
    let totalGroup = getTotalGroup();
    console.log('totalGroup', totalGroup);

    if (PDF_HIDE_GROUP_COLUMN)
      totalGroup += 1;

    const columnGroupsToExport = getColumnGroupsToExport(totalGroup);
    //console.log('columnGroupsToExport', columnGroupsToExport);

    const columnsToExportWithGroup = getColumnsToExport(totalGroup);
    //console.log('columnsToExportWithGroup', columnsToExportWithGroup);

    const columnsToExport = columnsToExportWithGroup.filter(col => !col.temp);
    //console.log('columnsToExport', columnsToExport);

    const widths = getExportedColumnsWidths(columnsToExportWithGroup);

    const rowsToExport = getRowsToExport(columnsToExport, totalGroup);

    const body = columnGroupsToExport
      ? [columnGroupsToExport, columnsToExportWithGroup, ...rowsToExport]
      : [columnsToExportWithGroup, ...rowsToExport];

    // const body = [
    //   ["Column 1", "Column 2", "Column 3"],
    //   ["One value goes here", "Another one here", "OK?"]
    // ];

    const title = PDF_TITLE
      ? {
        alignment: 'center',
        text: PDF_TITLE,
        style: 'header',
        fontSize: 12,
        bold: true,
        margin: [0, 0],
      }
      : null;

    const subTitle = PDF_SUB_TITLE
      ? {
        alignment: 'center',
        text: PDF_SUB_TITLE,
        style: 'header',
        fontSize: 10,
        bold: true,
        margin: [0, 0],
      }
      : null;

    const generatedOn = PDF_GENERATED_ON
      ? {
        alignment: 'center',
        text: PDF_GENERATED_ON,
        style: 'header',
        fontSize: 10,
        bold: true,
        margin: [0, 0],
      }
      : null;

    const headerRows = columnGroupsToExport ? 2 : 1;

    const header = PDF_WITH_HEADER_IMAGE
      ? {
        image: "ag-grid-logo",
        width: 150,
        alignment: "center",
        margin: [0, 10, 0, 10],
      }
      : null;

    const footer = PDF_WITH_FOOTER_PAGE_COUNT
      ? function (currentPage, pageCount) {
        return {
          text: currentPage.toString() + " of " + pageCount,
          margin: [20]
        };
      }
      : null;

    const pageMargins = [
      10,
      PDF_WITH_HEADER_IMAGE ? 70 : 20,
      10,
      PDF_WITH_FOOTER_PAGE_COUNT ? 40 : 10
    ];

    const heights = rowIndex =>
      rowIndex < headerRows ? PDF_HEADER_HEIGHT : PDF_ROW_HEIGHT;

    const fillColor = (rowIndex, node, columnIndex) => {
      if (rowIndex < node.table.headerRows) {
        return PDF_HEADER_COLOR;
      }
      return rowIndex % 2 === 0 ? PDF_ODD_BKG_COLOR : PDF_EVEN_BKG_COLOR;
    };

    const hLineWidth = (i, node) =>
      i === 0 || i === node.table.body.length ? 1 : 1;

    const vLineWidth = (i, node) =>
      i === 0 || i === node.table.widths.length ? 1 : 0;

    const hLineColor = (i, node) =>
      i === 0 || i === node.table.body.length
        ? PDF_OUTER_BORDER_COLOR
        : PDF_INNER_BORDER_COLOR;

    const vLineColor = (i, node) =>
      i === 0 || i === node.table.widths.length
        ? PDF_OUTER_BORDER_COLOR
        : PDF_INNER_BORDER_COLOR;

    const docDefintiion = {
      /* pageSize: {
        width: 200,
        height: 'auto'
      }, */
      pageSize: PDF_PAGE_SIZE,
      pageOrientation: PDF_PAGE_ORITENTATION,
      header,
      footer,
      content: [
        title,
        subTitle,
        generatedOn,
        {
          style: "myTable",
          table: {
            headerRows,
            widths,
            body,
            heights
          },
          layout: {
            fillColor,
            hLineWidth,
            vLineWidth,
            hLineColor,
            vLineColor
          }
        }
      ],
      images: {
        "ag-grid-logo": PDF_LOGO
      },
      styles: {
        myTable: {
          margin: [0, 0, 0, 0]
        },
        tableHeader: {
          bold: true,
          fontSize: 7,
          margin: [0, PDF_HEADER_HEIGHT / 3, 0, 0]
        },
        tableCell: {
          bold: false,
          fontSize: 6,
          // margin: [0, 15, 0, 0]
        },
        tableFooter: {
          bold: true,
          fontSize: 7,
        }
      },
      pageMargins
    };

    return docDefintiion;
  })();

  function getColumnGroupsToExport(totalGroup) {
    let displayedColumnGroups = agGridColumnApi.getAllDisplayedColumnGroups();
    let isColumnGrouping = displayedColumnGroups.some(col =>
      col.hasOwnProperty("children")
    );

    if (!isColumnGrouping) {
      return null;
    }

    let columnGroupsToExport = [];
    displayedColumnGroups.forEach((colGroup, index) => {
      let isColSpanning = colGroup.children.length > 0;
      let numberOfEmptyHeaderCellsToAdd = 0;
      if (isColSpanning) {
        if (index === 0 && totalGroup > 1) {
          let headerCell = createHeaderCell(colGroup, '', totalGroup);
          columnGroupsToExport.push(headerCell);
          let blankCell = getBlankCell(totalGroup - 1);
          columnGroupsToExport.push(...blankCell);
        }
        else {
          let headerCell = createHeaderCell(colGroup, '');
          columnGroupsToExport.push(headerCell);
        }
        // subtract 1 as the column group counts as a header
        numberOfEmptyHeaderCellsToAdd--;
      }

      // add an empty header cell now for every column being spanned
      colGroup.displayedChildren.forEach(childCol => {
        let pdfExportOptions = getPdfExportOptions(childCol.getColId());
        if (!pdfExportOptions || !pdfExportOptions.skipColumn) {
          numberOfEmptyHeaderCellsToAdd++;
        }
      });

      for (let i = 0; i < numberOfEmptyHeaderCellsToAdd; i++) {
        columnGroupsToExport.push({});
      }
    });

    return columnGroupsToExport;
  }

  function getColumnsToExport(totalGroup) {
    let columnsToExport = [];
    agGridColumnApi.getAllDisplayedColumns().forEach((col, index) => {
      let pdfExportOptions = col.colDef.pdfExportOptions ? col.colDef.pdfExportOptions : '';
      if (pdfExportOptions && pdfExportOptions.skipColumn) {
        return;
      }
      if (index === 0 && totalGroup > 1) {
        let headerCell = createHeaderCell(col, pdfExportOptions, totalGroup);
        columnsToExport.push(headerCell);
        let blankCell = getBlankCell(totalGroup - 1);
        columnsToExport.push(...blankCell);
      }
      else {
        let headerCell = createHeaderCell(col, pdfExportOptions);
        columnsToExport.push(headerCell);
      }
    });

    return columnsToExport;
  }

  function getRowsToExport(columnsToExport, totalGroup) {
    let rowsToExport = [];
    let groupFooters = {};  // To track group nodes by their levels

    // Get the grid options wrapper
    const gridOptionsWrapper = agGridApi.gridOptionsWrapper;
    const groupIncludeFooter = gridOptionsWrapper.isGroupIncludeFooter();
    //console.log('groupIncludeFooter', groupIncludeFooter);

    agGridApi.forEachNodeAfterFilterAndSort(node => {
      console.log('node', node);
      if (PDF_SELECTED_ROWS_ONLY && !node.isSelected()) {
        return;
      }

      if (PDF_SUMMARY && !node.group) return;

      if (agGridColumnApi.isPivotMode() && !node.group) return;

      // total row 
      if (PDF_ROW_TOTAL && ((node.parent.key && PDF_ROW_TOTAL.indexOf(node.parent.key) >= 0) ||
        PDF_ROW_TOTAL.indexOf(node.key) >= 0)
      ) {
        if (node.level === 0) {
          let rowToExport = createTableFooterRow(columnsToExport, node);
          rowsToExport.push(rowToExport);
        }
        return;
      }

      if (isNotShowingGroupTotal(node)) {
        //console.log('is not showing');
        let rowToExport = Array.from({ length: node.level }, () => ({
          text: "",
          style: "tableCell",
          alignment: "left",
          colSpan: 0,
          preserveLeadingSpaces: true,
          colId: node.id,
          bold: true,
          fontSize: 7
        }));

        let colSpan = columnsToExport.length;
        //console.log('total group at node group', totalGroup); // total group = 2

        if (totalGroup > 0) {
          colSpan = columnsToExport.length + (totalGroup - 1) - node.level;
        }
        //console.log('colspan', colSpan);

        const tableCell = {
          text: node.key,
          style: "tableCell",
          alignment: "left",
          colSpan: colSpan,
          preserveLeadingSpaces: true,
          colId: node.id,
          bold: true,
          fontSize: 7
        };
        rowToExport.push(tableCell);

        groupFooters[node.level] = node;

        // blank cell for colSpan
        let blankCell = getBlankCell(colSpan - 1);
        rowToExport.push(...blankCell);

        rowsToExport.push(rowToExport);
      }
      else {
        let rowToExport = [];
        //console.log('columns to export', columnsToExport);
        columnsToExport.forEach(({ colId, pdfExportOptions, colSpan }, index) => {
          let cellValue = agGridApi.getValue(colId, node);
          //console.log('index', index);
          //console.log('colspan', colSpan);
          //console.log('level', node.level);
          //console.log('colId', colId);
          if (index === 0 ) {
            colSpan = colSpan - node.level;
            let firstTableCell = createTableCell(node, cellValue, colId, pdfExportOptions, colSpan);
            let blankCells = getBlankCell(colSpan - 1);
            //console.log('firstTableCell', firstTableCell);
            //console.log('blank cells', blankCells);
            rowToExport.push(firstTableCell, ...blankCells);
            
          } else {
            let tableCell = createTableCell(node, cellValue, colId, pdfExportOptions);
            //console.log('table cell', tableCell);
            rowToExport.push(tableCell);
          }
        });

        let rowFinal = [...rowToExport];
        if (totalGroup > 0) {
          //let totalBlank = ((isAutoGroupColumn() || PDF_PIVOT_MODE) && !node.group ? node.level - 1 : node.level);
          let totalBlank = PDF_HIDE_GROUP_COLUMN ? node.level : node.group ? node.level : totalGroup - 1;
          //let totalBlank = node.group ? node.level : node.level;
          let rowToExportBlank = Array.from({ length: totalBlank }, () => ({
            text: "",
            style: "tableCell",
            alignment: "left",
            colSpan: 0,
            preserveLeadingSpaces: true,
            colId: node.id,
            bold: true,
            fontSize: 7
          }));
          // console.log('node group', node.group);
          // console.log(totalGroup);  
          // console.log('total blank', totalBlank);
          // console.log(rowToExportBlank);
          // console.log(rowToExport);
          rowFinal = [...rowToExportBlank, ...rowToExport];
        }
        rowsToExport.push(rowFinal);

        // group footer
        if (node.lastChild) {
          // Function to handle footer creation at each level
          let currentNode = node;
          while (currentNode) {
            const groupFooterNote = groupFooters[currentNode.level-1];
            if (groupFooterNote) {
              // Create a footer row for the current group level
              if (currentNode.lastChild) {
                let rowFooter = createTableFooterRow(columnsToExport, groupFooterNote, true);
                rowsToExport.push(rowFooter);
                delete groupFooters[currentNode.level-1];  // Delete footer after adding
              }
              // Move up to the parent level for nested groups
              currentNode = currentNode.parent;
            } else {
              // If no group footer note exists, break the loop
              break;
            }
          }
        }
      }
    });

    // Check the value of groupIncludeTotalFooter
    const groupIncludeTotalFooter = gridOptionsWrapper.isGroupIncludeTotalFooter();
    if (groupIncludeTotalFooter) {
      let footerNode = agGridApi.getDisplayedRowAtIndex(agGridApi.getDisplayedRowCount() - 1);
      if (footerNode && footerNode.footer) {
        let rowFooter = createTableFooterRow(columnsToExport, footerNode);
        rowsToExport.push(rowFooter);
      }
    }
    return rowsToExport;
  }

  function getExportedColumnsWidths(columnsToExport) {
    return columnsToExport.map(() => 100 / columnsToExport.length + "%");
  }

  function createHeaderCell(col, pdfExportOptions, colSpan) {
    let headerCell = {};
    let isColGroup = col.hasOwnProperty("children");
    if (isColGroup) {
      headerCell.text = col.providedColumnGroup.colGroupDef?.headerName;
      headerCell.colSpan = colSpan > 0 ? colSpan : col.children.length;
      headerCell.colId = col.groupId;
      headerCell.alignment = col.children.length > 1 ? 'center' : 'right';
    } else {
      let headerName = col.colDef.headerName;

      if (col.sort) {
        headerName += ` (${col.sort})`;
      }
      if (col.filterActive) {
        headerName += ` [FILTERING]`;
      }

      headerCell.text = headerName;
      headerCell.colId = col.getColId();
      if (colSpan) headerCell.colSpan = colSpan;
    }

    headerCell.pdfExportOptions = pdfExportOptions;
    headerCell["style"] = "tableHeader";

    if (pdfExportOptions && pdfExportOptions.headerStyles) {
      Object.entries(pdfExportOptions.headerStyles).forEach(
        ([key, value]) => (headerCell[key] = value)
      );
    }

    return headerCell;
  }

  function createTableCell(node, cellValue, colId, pdfExportOptions, colSpan) {
    const tableCell = {
      text: cellValue ? cellValue : "",
      // noWrap: PDF_PAGE_ORITENTATION === "landscape",
      style: "tableCell",
      preserveLeadingSpaces: true,
      pdfExportOptions: pdfExportOptions,
      colSpan: colSpan
    };

    if (pdfExportOptions) {
      const { styles, createURL } = pdfExportOptions;
      if (PDF_WITH_CELL_FORMATTING && styles) {
        Object.entries(styles).forEach(
          ([key, value]) => {
            if (key === 'currencyFormatter' && value) {
              tableCell["text"] = cellValue ? SharedUtilitiesModule.currencyFormatter(cellValue) : "0.00";
              if (PDF_ROW_PERCENTAGE && PDF_ROW_PERCENTAGE.indexOf(node.key) >= 0) {
                tableCell["text"] += '%';
              }
            }
            else if (key === 'dateFormatter' && value) {
              tableCell["text"] = cellValue ? moment(cellValue).format('YYYY-MM-DD') : "";
            }
            else if (key === 'dateTimeFormatter' && value) {
              tableCell["text"] = cellValue ? moment(cellValue).format('YYYY-MM-DD HH:mm:ss') : "";
            }
            else {
              (tableCell[key] = value);
            }
          }
        );
      }

      if (PDF_WITH_COLUMNS_AS_LINKS && createURL) {
        tableCell["link"] = createURL(cellValue);
        tableCell["color"] = "blue";
        tableCell["decoration"] = "underline";
      }
    }

    if (PDF_ROW_BOLD && PDF_ROW_BOLD.indexOf(node.key) >= 0 || (node.group)) {
      tableCell["bold"] = true;
      tableCell["fontSize"] = 7;
    }

    return tableCell;
  }

  function createTableFooterCell(node, cellValue, colId, pdfExportOptions, colSpan) {
    const tableCell = {
      text: cellValue ? cellValue : "",
      style: "tableFooter",
      pdfExportOptions: pdfExportOptions,
      colSpan: colSpan
    };

    if (pdfExportOptions) {
      const { styles, createURL } = pdfExportOptions;
      if (PDF_WITH_CELL_FORMATTING && styles) {
        Object.entries(styles).forEach(
          ([key, value]) => {
            if (key === 'currencyFormatter' && value) {
              tableCell["text"] = cellValue ? SharedUtilitiesModule.currencyFormatter(cellValue) : "0.00";
              if (PDF_ROW_PERCENTAGE && PDF_ROW_PERCENTAGE.indexOf(node.key) >= 0) {
                tableCell["text"] += '%';
              }
            }
            else if (key === 'dateFormatter' && value) {
              tableCell["text"] = cellValue ? moment(cellValue).format('YYYY-MM-DD') : "";
            }
            else if (key === 'dateTimeFormatter' && value) {
              tableCell["text"] = cellValue ? moment(cellValue).format('YYYY-MM-DD HH:mm:ss') : "";
            }
            else {
              (tableCell[key] = value);
            }
          }
        );
      }
    }

    return tableCell;
  }

  function getPdfExportOptions(colId) {
    let col = agGridColumnApi.getColumn(colId);
    return col ? col.colDef.pdfExportOptions : '';
  }

  function isNullOrEmptyObject(value) {
    return !value || (typeof value === 'object' && Object.keys(value).length === 0);
  }

  function getBlankCell(colSpan) {
    let rowToExport = Array.from({ length: colSpan }, () => ({
      text: "",
      temp: true
    }));
    return rowToExport;
  }

  function getTotalGroup() {
    const rowGroupColumns = agGridColumnApi.getAllColumns().filter(col => col.getColDef().rowGroup);
    //console.log('rowGroupColumns', rowGroupColumns);
    const rowActiveGroupColumns = agGridColumnApi.getAllColumns().filter(col => col.rowGroupActive);
    //console.log('rowActiveGroupColumns', rowActiveGroupColumns);

    if (rowGroupColumns && rowGroupColumns.length > 0) {
      return rowGroupColumns.length;
    }
    else if (rowActiveGroupColumns && rowActiveGroupColumns.length > 0) {
      return rowActiveGroupColumns.length;
    }
    else {
      return 0;
    }
  }

  function createTableFooterRow(columnsToExport, node, notShowText = false) {
    let rowToExport = [];
    columnsToExport.forEach(({ colId, pdfExportOptions, colSpan }, index) => {
      let cellValue = agGridApi.getValue(colId, node);
      if (index === 0 && colSpan > 1) {
        if (notShowText) cellValue = '';
        let firstTableCell = createTableFooterCell(node, cellValue, colId, pdfExportOptions, colSpan);
        let blankCells = getBlankCell(colSpan - 1);
        rowToExport.push(firstTableCell, ...blankCells);
      } else {
        let tableCell = createTableFooterCell(node, cellValue, colId, pdfExportOptions);
        rowToExport.push(tableCell);
      }
    });
    return rowToExport;
  }

  function isNotShowingGroupTotal(node) {
    if (PDF_NOT_SHOWING_GROUP_TOTAL && node.group) {
      if (agGridColumnApi.isPivotMode()) {
        return !node.leafGroup;
      }
      return true;
    }
    return false;
  }

  function isAutoGroupColumn() {
    return true;
    // let autoGroupColumn = agGridColumnApi.getAllDisplayedColumns().filter(
    //   col => col.colId.startsWith('ag-Grid-AutoColumn') && col.getColDef().headerName === 'Group'
    // );

    // if (autoGroupColumn && autoGroupColumn.length > 0) {
    //   return true;
    // }
    // else {
    //   const rowGroupColumns = agGridColumnApi.getAllColumns().filter(col => col.getColDef().rowGroup);
    //   console.log('rowGroupColumns', rowGroupColumns);

    // }
  }
}
